var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#474747"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.125v-1.5a1.5 1.5 0 0 0-1.5-1.5H12a2.355 2.355 0 0 0 .75-1.748A2.377 2.377 0 0 0 10.373 0 3.352 3.352 0 0 0 7.5 1.65 3.352 3.352 0 0 0 4.628 0 2.378 2.378 0 0 0 2.25 2.377 2.355 2.355 0 0 0 3 4.125H1.5a1.5 1.5 0 0 0-1.5 1.5v1.5a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5zM8.565 3a1.852 1.852 0 0 1 1.808-1.5.878.878 0 0 1 .127 1.74l-2.078.345L8.566 3zM4.628 1.5A1.852 1.852 0 0 1 6.434 3l.12.6L4.5 3.24a.878.878 0 0 1 .128-1.74zM1.125 9.337v3.788A1.875 1.875 0 0 0 3 15h3.75V9.375H1.5a1.552 1.552 0 0 1-.375-.038zM8.25 9.375V15H12a1.875 1.875 0 0 0 1.875-1.875V9.337c-.123.028-.249.04-.375.038H8.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.90b64dfc94b777b634aa4f1c23862f7e.svg";
export { ForwardRef as ReactComponent };